module.exports = require("./kl.d.ts");